import React from 'react';
import { MarginPage } from './MarginPage';

export const DistributorMargins: React.FC = () => {
  return <MarginPage type="distributor" title="Distributor Margins" />;
};

export default DistributorMargins;
